export default {
    data() {
        return {
            list_cylinders_moto: [
                'Choisir un type de cylindrée',
                '125 cm3',
                '125 à 650 cm3',
                '> 650 cm3',
            ],
            list_type_vehicule: [
                'Choisir un type de v&eacute;hicule...',
                'V.P',
                'V.U',
                '4X4',
            ],
            list_type_cylinder: [
                '', '- 2.5 L', '2.5 L - 3.5 L', '+ 3.5 L'
            ],
            list_type_carburant: [
                '', 'Gasoline', 'Diesel', 'GPL'
            ],
            list_type_car_carburant: [
                '', 'Essence', 'Diesel', 'GPL', 'Electrique', 'Hybride'
            ],
            list_marque_auto: [
                "Choisir une marque...",
                "Aixam",
                "Aleko",
                "Alfa Romeo",
                "Alpina",
                "Anaig",
                "Aro",
                "Aston Martin",
                "Audi",
                "Austin",
                "Autobianchi",
                "Auverland",
                "Bedford",
                "Bentley",
                "Bertone",
                "BMW",
                "Buick",
                "Cadillac",
                "Chevrolet",
                "Chrysler",
                "Citroen",
                "Dacia",
                "Daewoo",
                "Daf",
                "Daihatsu",
                "Dallas",
                "Dangel",
                "De La Chapelle",
                "Dodge",
                "Donkervoort",
                "Ferrari",
                "Fiat",
                "Ford",
                "Fso",
                "Gme",
                "Honda",
                "Hyundai",
                "Innocenti",
                "Isuzu",
                "Iveco",
                "Jaguar",
                "Kia",
                "Lada",
                "Lamborghini",
                "Lancia",
                "Land Rover",
                "Lexus",
                "Ligier",
                "Lotus",
                "Mahindra",
                "Maruti",
                "Maserati",
                "Mazda",
                "Mercedes",
                "Microcar",
                "Mitsubishi",
                "Morgan",
                "Nissan",
                "Opel",
                "Peugeot",
                "Piaggio",
                "Polski",
                "Polski/fso",
                "Poncin",
                "Pontiac",
                "Porsche",
                "Proton",
                "Renault",
                "Renault V.i",
                "Rolls Royce",
                "Rover",
                "Saab",
                "Santana",
                "Seat",
                "Skoda",
                "Smart",
                "Sovamag",
                "Ssangyong",
                "Subaru",
                "Suzuki",
                "Talbot",
                "Tata",
                "Tavria",
                "Teilhom",
                "Tesla",
                "Toyota",
                "TVR",
                "Umm",
                "Venturi",
                "Volkswagen",
                "Volvo",
                "Victory",
                "Yugo",
                "Zastava",
            ],
            list_marque_moto: [
                "Choisir une marque...",
                "Aprilia",
                "Bimota",
                "BMW",
                "BMW Hechard",
                "Buell",
                "Cagiva",
                "Daelim",
                "Derby",
                "Ducati",
                "Fantic",
                "FN",
                "Gilera",
                "Gima",
                "Harley",
                "Harley Davidson",
                "Honda",
                "Honda + Side 2 Pl",
                "Honda + Side Panda",
                "Husaberg",
                "Husqvarna",
                "Jacksport",
                "Kawasaki",
                "Kawasaki + Side",
                "Kawasaki + Side Jewel",
                "Kimco",
                "KTM",
                "Kymco",
                "Laverda",
                "MBK",
                "Megaphone",
                "Motoguzzi",
                "MZ",
                "Norton",
                "Peugeot",
                "Piaggio",
                "Scorpa",
                "Suzuki",
                "Triumph",
                "Vespa",
                "Vor",
                "Voxan",
                "Victory",
                "Yamaha",
                "Yamaha + Side",
                "Zundapp"
            ],
            list_months: [
                'Janvier',
                'Février',
                'Mars',
                'Avril',
                'Mai',
                'Juin',
                'Juillet',
                'Août',
                'Septembre',
                'Octobre',
                'Novembre',
                'Décembre',
            ],
        }
    },
    methods: {
        generateYearsList(from, to) {
            let years = [];
            for (let i = from; i <= to; i++) {
                years.push(i)
            }
            return years;
        }
    },
    computed: {
        list_days() {
            let days = [];
            for (let i = 1; i <= 31; i++) {
                days.push(i);
            }
            return days;
        },
        list_past_years() {
            let currentYear = new Date().getFullYear();
            return this.generateYearsList(currentYear - 99, currentYear).reverse();
        },
        list_future_years() {
            let currentYear = new Date().getFullYear();
            return this.generateYearsList(currentYear, currentYear + 99);
        },
        list_year_of_born() {
            let currentYear = new Date().getFullYear();
            return this.generateYearsList(currentYear - 99, currentYear - 18);
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/garantieFieldsLists.js